<template>
  <a-tabs
      v-model:activeKey="searchForm.table"
      style="background-color: #fff; padding: 0 12px"
      @change="getTableData()"
  >
    <a-tab-pane key="1" tab="按时间"></a-tab-pane>
    <a-tab-pane key="2" tab="按房间"></a-tab-pane>
    <a-tab-pane key="3" tab="按渠道"></a-tab-pane>
  </a-tabs>

  <div style="background-color: #fff; padding: 0 10px 10px 10px">
    <!-- 搜索 -->
    <div ref="topDom" class="header-bar">
      <div class="bar-lef">
        <div class="lef-group">
          <!-- <div class="group-one">
            <a-select
              v-model:value="searchForm.time_table"
              @change="getTableData()"
            >
              <a-select-option :value="1">下单时间</a-select-option>
              <a-select-option :value="2">入住时间</a-select-option>
              <a-select-option :value="3">退房时间</a-select-option>
            </a-select>
          </div> -->
          <div class="group-one" style="width: 220px">
            <a-range-picker
                v-model:value="rangePicker"
                :ranges="ranges"
                @change="handlePicker"
            />
          </div>
          <div class="group-one">
            <a-select
                v-model:value="searchForm.rids"
                :dropdownMatchSelectWidth="false"
                :filterOption="roomFilter"
                :max-tag-count="1"
                mode="multiple"
                placeholder="房型"
                @change="getTableData"
            >
              <a-select-option
                  v-for="(item, index) in searchList.room.list"
                  :key="index"
                  :value="item.id"
              >{{ item.name }}
              </a-select-option
              >
            </a-select>
          </div>
          <div class="group-one">
            <a-select
                v-model:value="searchForm.gids"
                :dropdownMatchSelectWidth="false"
                :filterOption="groupFilter"
                :max-tag-count="1"
                mode="multiple"
                placeholder="分组"
                @change="getTableData"
            >
              <a-select-option
                  v-for="(item, index) in searchList.group.list"
                  :key="index"
                  :value="item.id"
              >{{ item.name }}
              </a-select-option
              >
            </a-select>
          </div>
          <div v-if="searchForm.table == 3" class="group-one">
            <a-select
                v-model:value="searchForm.source_ids"
                :dropdownMatchSelectWidth="false"
                :max-tag-count="1"
                mode="multiple"
                placeholder="渠道"
                @change="getTableData"
            >
              <a-select-option
                  v-for="(item, index) in searchList.source.list"
                  :key="index"
                  :value="item.id"
              >{{ item.name }}
              </a-select-option
              >
            </a-select>
          </div>
        </div>
        <div class="lef-one">
          <a-input-search
              v-model:value="searchForm.name"
              :loading="searchLoading"
              placeholder="请输入房间名称"
              @search="getTableData"
          >
          </a-input-search>
        </div>
        <div class="lef-one-no-shadow">
          <a-button type="link" @click="handleReset">重置筛选</a-button>
        </div>
      </div>
      <div class="bar-rig">
        <div class="rig-one">
          <a-popover
              v-model:visible="visiblePopover"
              placement="bottom"
              trigger="click"
          >
            <template #content>
              <template v-for="(item, index) in initColumns" :key="index">
                <div v-if="item.title" style="margin: 5px 0">
                  <a-checkbox v-model:checked="item.isShow">{{
                      item.title
                    }}
                  </a-checkbox>
                </div>
              </template>
              <a-button
                  size="small"
                  style="margin-right: 5px"
                  @click="handleResetCheck"
              >重置
              </a-button
              >
              <a-button class="btn-primary" size="small" @click="handleCheck"
              >确认
              </a-button
              >
            </template>
            <a-button>
              <appstore-outlined/>
              视图
            </a-button>
          </a-popover>
        </div>
        <div class="rig-one">
          <a-button>
            <upload-outlined/>
            导出
          </a-button>
        </div>
      </div>
    </div>

    <!-- 表格 -->
    <a-table
        :columns="columns"
        :dataSource="dataSource"
        :loading="searchLoading"
        :pagination="false"
        :scroll="{ x: columns.length > 6 ? 2500 : 0, y: tableHeight }"
        bordered
        class="table"
        size="small"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key == 'side_name'">
          <span v-if="searchForm.table == 1">
            {{
              record.side_name
            }}<span class="f-c-999" style="margin: 0 5px">|</span>
            <span
                :class="{ fRed: record.week == '六' || record.week == '日' }"
            >{{ record.week }}</span
            >
          </span>
          <span v-else-if="searchForm.table == 2">{{ record.side_name }}</span>
        </template>
      </template>
    </a-table>
  </div>
</template>

<script>
import {nextTick, onMounted, reactive, toRefs, watch} from "vue";
import {getSearchList, operateChannelList, operateList} from "@/api/api";
import dayjs from "dayjs";
import {AppstoreOutlined, UploadOutlined} from "@ant-design/icons-vue";
import useUtils from "@/hooks/useUtils.js"; //工具库
import store from "@/store/pms/landlord/index";

export default {
  components: {
    UploadOutlined,
    AppstoreOutlined,
  },
  setup() {
    let {countTable} = useUtils();

    const search = reactive({
      topDom: "",
      searchLoading: false,
      searchForm: {
        table: 1,
        // time_table: 1,
        name: "",
        source_ids: [],
        rids: [],
        gids: [],
        start_date: "",
        end_date: "",
      },
      rangePicker: [],
      visiblePopover: false,
      ranges: {
        昨天: [dayjs().subtract(1, "day"), dayjs().subtract(1, "day")],
        今天: [dayjs(), dayjs()],
        明天: [dayjs().add(1, "day"), dayjs().add(1, "day")],
        最近7天: [dayjs().subtract(7, "day"), dayjs()],
        最近30天: [dayjs().subtract(30, "day"), dayjs()],
        上月: [
          dayjs().subtract(1, "month").startOf("month"),
          dayjs().subtract(1, "month").endOf("month"),
        ],
        本月: [dayjs().startOf("month"), dayjs().endOf("month")],

        上季度: [
          dayjs().startOf("month").add(-1, "year").month(9),
          dayjs().endOf("month").add(-1, "year").month(11),
        ],
        本季度: [
          dayjs().startOf("month").month(0),
          dayjs().endOf("month").month(2),
        ],
      },
      searchList: {
        deposit: {},
        group: {},
        income: {},
        inout: {},
        paytype: {},
        room: {},
        source: {},
        tag: {},
      },
      getSearchData() {
        if (!search.searchList.length) {
          getSearchList().then((res) => {
            search.searchList = res.data;
          });
        }
      },
      handlePicker(_params, value) {
        search.searchForm.start_date = value[0];
        search.searchForm.end_date = value[1];
        table.getTableData();
      },
      handleReset() {
        search.searchForm.name = "";
        search.rangePicker = [];
        search.searchForm.source_ids = [];
        search.searchForm.gids = [];
        search.searchForm.rids = [];
        search.searchForm.name = "";
        search.searchForm.start_date = "";
        search.searchForm.end_date = "";
        table.getTableData();
      },
      handleCheck() {
        table.columns = table.initColumns.filter((item) => {
          return item.isShow;
        });
        search.visiblePopover = false;
      },
      handleResetCheck() {
        table.initColumns.map((item) => {
          item.isShow = true;
        });
        table.columns = JSON.parse(JSON.stringify(table.initColumns));
        search.visiblePopover = false;
      },
      groupFilter(input, option) {
        return (
            option.children[0].children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
        );
      },
      roomFilter(input, option) {
        return (
            option.children[0].children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
        );
      },
    });

    function getColumns() {
      return [
        {
          title: "",
          isShow: true,
          children: [
            {
              title: search.searchForm.table == 1 ? "时间" : "房间",
              align: "center",
              children: [
                {
                  title: "总计",
                  dataIndex: "side_name",
                  key: "side_name",
                  align: "center",
                  width: 100,
                  fixed: "left",
                  ellipsis: true,
                },
              ],
            },
          ],
        },
        {
          title: "新单",
          isShow: true,
          children: [
            {
              title: "数量",
              align: "center",
              children: [
                {
                  title: table.topData.order_count,
                  dataIndex: "order_count",
                  key: "order_count",
                  align: "center",
                  width: 100,
                },
              ],
            },
            {
              title: "金额",
              align: "center",
              children: [
                {
                  title: table.topData.order_amount,
                  dataIndex: "order_amount",
                  key: "order_amount",
                  align: "center",
                  width: 100,
                },
              ],
            },
          ],
        },
        {
          title: "入离",
          isShow: true,
          children: [
            {
              title: "入住",
              align: "center",
              children: [
                {
                  title: table.topData.check_in,
                  dataIndex: "check_in",
                  key: "check_in",
                  align: "center",
                  width: 100,
                },
              ],
            },
            {
              title: "退房",
              align: "center",
              children: [
                {
                  title: table.topData.check_out,
                  dataIndex: "check_out",
                  key: "check_out",
                  align: "center",
                  width: 100,
                },
              ],
            },
          ],
        },
        {
          title: "房间",
          isShow: true,
          children: [
            {
              title: "可售",
              align: "center",
              children: [
                {
                  title: table.topData.sale,
                  dataIndex: "sale",
                  key: "sale",
                  align: "center",
                  width: 100,
                },
              ],
            },
            {
              title: "已售",
              align: "center",
              children: [
                {
                  title: table.topData.sale_out,
                  dataIndex: "sale_out",
                  key: "sale_out",
                  align: "center",
                  width: 100,
                },
              ],
            },
            {
              title: "入住率",
              align: "center",
              children: [
                {
                  title: table.topData.sale_out_rate,
                  dataIndex: "sale_out_rate",
                  key: "sale_out_rate",
                  align: "center",
                  width: 100,
                },
              ],
            },
          ],
        },
        {
          title: "订单费用",
          isShow: true,
          children: [
            {
              title: "房费",
              align: "center",
              children: [
                {
                  title: table.topData.house_amount,
                  dataIndex: "house_amount",
                  key: "house_amount",
                  align: "center",
                  width: 100,
                },
              ],
            },
            {
              title: "佣金",
              align: "center",
              children: [
                {
                  title: table.topData.house_royalty,
                  dataIndex: "house_royalty",
                  key: "house_royalty",
                  align: "center",
                  width: 100,
                },
              ],
            },
            {
              title: "净房费",
              align: "center",
              children: [
                {
                  title: table.topData.house_room_price,
                  dataIndex: "house_room_price",
                  key: "house_room_price",
                  align: "center",
                  width: 100,
                },
              ],
            },
          ],
        },
        {
          title: "均价",
          isShow: true,
          children: [
            {
              title: "房费",
              align: "center",
              children: [
                {
                  title: table.topData.average_house_amount,
                  dataIndex: "average_house_amount",
                  key: "average_house_amount",
                  align: "center",
                  width: 100,
                },
              ],
            },
            {
              title: "净房费",
              align: "center",
              children: [
                {
                  title: table.topData.average_house_room_price,
                  dataIndex: "average_house_room_price",
                  key: "average_house_room_price",
                  align: "center",
                  width: 100,
                },
              ],
            },
          ],
        },
        {
          title: "RevPAR",
          isShow: true,
          children: [
            {
              title: "房费",
              align: "center",
              children: [
                {
                  title: table.topData.revpay_house_amount,
                  dataIndex: "revpay_house_amount",
                  key: "revpay_house_amount",
                  align: "center",
                  width: 100,
                },
              ],
            },
            {
              title: "净房费",
              align: "center",
              children: [
                {
                  title: table.topData.revpay_house_room_price,
                  dataIndex: "revpay_house_room_price",
                  key: "revpay_house_room_price",
                  align: "center",
                  width: 100,
                },
              ],
            },
          ],
        },
        {
          title: "订单收支",
          isShow: true,
          children: [
            {
              title: "收入",
              align: "center",
              children: [
                {
                  title: table.topData.order_income,
                  dataIndex: "order_income",
                  key: "order_income",
                  align: "center",
                  width: 100,
                },
              ],
            },
            {
              title: "支出",
              align: "center",
              children: [
                {
                  title: table.topData.order_expend,
                  dataIndex: "order_expend",
                  key: "order_expend",
                  align: "center",
                  width: 100,
                },
              ],
            },
            {
              title: "净收入",
              align: "center",
              children: [
                {
                  title: table.topData.order_income_net,
                  dataIndex: "order_income_net",
                  key: "order_income_net",
                  align: "center",
                  width: 100,
                },
              ],
            },
          ],
        },
        {
          title: "订单外收支",
          isShow: true,
          children: [
            {
              title: "收入",
              align: "center",
              children: [
                {
                  title: table.topData.income,
                  dataIndex: "income",
                  key: "income",
                  align: "center",
                  width: 100,
                },
              ],
            },
            {
              title: "支出",
              align: "center",
              children: [
                {
                  title: table.topData.expend,
                  dataIndex: "expend",
                  key: "expend",
                  align: "center",
                  width: 100,
                },
              ],
            },
            {
              title: "净收入",
              align: "center",
              children: [
                {
                  title: table.topData.net_income,
                  dataIndex: "net_income",
                  key: "net_income",
                  align: "center",
                  width: 100,
                },
              ],
            },
          ],
        },
      ];
    }

    function getChannelColumns() {
      return [
        {
          title: "",
          isShow: true,
          children: [
            {
              title: "渠道",
              align: "center",
              children: [
                {
                  title: "总计",
                  dataIndex: "name",
                  key: "name",
                  align: "center",
                  width: 100,
                  fixed: "left",
                  ellipsis: true,
                },
              ],
            },
          ],
        },
        {
          title: "订单",
          isShow: true,
          children: [
            {
              title: "数量",
              align: "center",
              children: [
                {
                  title: table.topData.order_num,
                  dataIndex: "order_num",
                  key: "order_num",
                  align: "center",
                  width: 100,
                },
              ],
            },
            {
              title: "占比",
              align: "center",
              children: [
                {
                  title: table.topData.order_num_rate,
                  dataIndex: "order_num_rate",
                  key: "order_num_rate",
                  align: "center",
                  width: 100,
                },
              ],
            },
          ],
        },
        {
          title: "已售",
          isShow: true,
          children: [
            {
              title: "数量",
              align: "center",
              children: [
                {
                  title: table.topData.sale_num,
                  dataIndex: "sale_num",
                  key: "sale_num",
                  align: "center",
                  width: 100,
                },
              ],
            },
            {
              title: "占比",
              align: "center",
              children: [
                {
                  title: table.topData.sale_num_rate,
                  dataIndex: "sale_num_rate",
                  key: "sale_num_rate",
                  align: "center",
                  width: 100,
                },
              ],
            },
          ],
        },
        {
          title: "房费",
          isShow: true,
          children: [
            {
              title: "金额",
              align: "center",
              children: [
                {
                  title: table.topData.house_amount,
                  dataIndex: "house_amount",
                  key: "house_amount",
                  align: "center",
                  width: 100,
                },
              ],
            },
            {
              title: "占比",
              align: "center",
              children: [
                {
                  title: table.topData.house_amount_rate,
                  dataIndex: "house_amount_rate",
                  key: "house_amount_rate",
                  align: "center",
                  width: 100,
                },
              ],
            },
            {
              title: "均价",
              align: "center",
              children: [
                {
                  title: table.topData.average_price,
                  dataIndex: "average_price",
                  key: "average_price",
                  align: "center",
                  width: 100,
                },
              ],
            },
          ],
        },
        {
          title: "佣金",
          isShow: true,
          children: [
            {
              title: "金额",
              align: "center",
              children: [
                {
                  title: table.topData.royalty,
                  dataIndex: "royalty",
                  key: "royalty",
                  align: "center",
                  width: 100,
                },
              ],
            },
            {
              title: "占比",
              align: "center",
              children: [
                {
                  title: table.topData.royalty_rate,
                  dataIndex: "royalty_rate",
                  key: "royalty_rate",
                  align: "center",
                  width: 100,
                },
              ],
            },
          ],
        },
        {
          title: "净房费",
          isShow: true,
          children: [
            {
              title: "房费",
              align: "center",
              children: [
                {
                  title: table.topData.house_amount,
                  dataIndex: "house_amount",
                  key: "house_amount",
                  align: "center",
                  width: 100,
                },
              ],
            },
            {
              title: "净房费",
              align: "center",
              children: [
                {
                  title: table.topData.house_room_price,
                  dataIndex: "house_room_price",
                  key: "house_room_price",
                  align: "center",
                  width: 100,
                },
              ],
            },
          ],
        },
      ];
    }

    const table = reactive({
      tableHeight: "",
      dataSource: [],
      topData: {},
      initColumns: [],
      getTableData() {
        search.searchLoading = true;
        if (search.searchForm.table == 3) {
          operateChannelList({
            table: search.searchForm.table,
            name: search.searchForm.name,
            source_ids: search.searchForm.source_ids.toString(),
            rids: search.searchForm.rids.toString(),
            gids: search.searchForm.gids.toString(),
            start_date: search.searchForm.start_date,
            end_date: search.searchForm.end_date,
            // time_table: search.searchForm.time_table,
          })
              .then((res) => {
                table.dataSource = [];
                table.topData = res.data.top;
                for (let i = 0; i < res.data.list.length; i++) {
                  table.dataSource.push(
                      Object.assign(res.data.list[i], res.data.left[i])
                  );
                }
                nextTick(() => {
                  table.columns = getChannelColumns();
                  table.initColumns = getChannelColumns();
                });
                search.searchLoading = false;
              })
              .catch(() => {
                search.searchLoading = false;
              });
        } else {
          operateList({
            table: search.searchForm.table,
            name: search.searchForm.name,
            source_ids: search.searchForm.source_ids.toString(),
            rids: search.searchForm.rids.toString(),
            gids: search.searchForm.gids.toString(),
            start_date: search.searchForm.start_date,
            end_date: search.searchForm.end_date,
            // time_table: search.searchForm.time_table,
          })
              .then((res) => {
                table.dataSource = [];
                table.topData = res.data.top;
                for (let i = 0; i < res.data.list.length; i++) {
                  table.dataSource.push(
                      Object.assign(res.data.list[i], res.data.left[i])
                  );
                }
                nextTick(() => {
                  table.columns = getColumns();
                  table.initColumns = getColumns();
                });
                search.searchLoading = false;
              })
              .catch(() => {
                search.searchLoading = false;
              });
        }
      },
      columns: [
        {
          title: "",
          children: [
            {
              title: "时间",
              align: "center",
              children: [
                {
                  title: "总计",
                  dataIndex: "side_name",
                  key: "side_name",
                  align: "center",
                  width: 200,
                  fixed: "left",
                },
              ],
            },
          ],
        },
        {
          title: "新单",
          children: [
            {
              title: "数量",
              align: "center",
              children: [
                {
                  title: "0",
                  dataIndex: "order_count",
                  key: "order_count",
                  align: "center",
                  width: 100,
                },
              ],
            },
            {
              title: "金额",
              align: "center",
              children: [
                {
                  title: "0",
                  dataIndex: "order_amount",
                  key: "order_amount",
                  align: "center",
                  width: 100,
                },
              ],
            },
          ],
        },
        {
          title: "入离",
          children: [
            {
              title: "入住",
              align: "center",
              children: [
                {
                  title: "0",
                  dataIndex: "check_in",
                  key: "check_in",
                  align: "center",
                  width: 100,
                },
              ],
            },
            {
              title: "退房",
              align: "center",
              children: [
                {
                  title: "0",
                  dataIndex: "check_out",
                  key: "check_out",
                  align: "center",
                  width: 100,
                },
              ],
            },
          ],
        },
        {
          title: "房间",
          children: [
            {
              title: "可售",
              align: "center",
              children: [
                {
                  title: "0",
                  dataIndex: "sale",
                  key: "sale",
                  align: "center",
                  width: 100,
                },
              ],
            },
            {
              title: "已售",
              align: "center",
              children: [
                {
                  title: "0",
                  dataIndex: "sale_out",
                  key: "sale_out",
                  align: "center",
                  width: 100,
                },
              ],
            },
            {
              title: "入住率",
              align: "center",
              children: [
                {
                  title: "0",
                  dataIndex: "sale_out_rate",
                  key: "sale_out_rate",
                  align: "center",
                  width: 100,
                },
              ],
            },
          ],
        },
        {
          title: "订单费用",
          children: [
            {
              title: "房费",
              align: "center",
              children: [
                {
                  title: "0",
                  dataIndex: "house_amount",
                  key: "house_amount",
                  align: "center",
                  width: 100,
                },
              ],
            },
            {
              title: "佣金",
              align: "center",
              children: [
                {
                  title: "0",
                  dataIndex: "house_royalty",
                  key: "house_royalty",
                  align: "center",
                  width: 100,
                },
              ],
            },
            {
              title: "净房费",
              align: "center",
              children: [
                {
                  title: "0",
                  dataIndex: "house_room_price",
                  key: "house_room_price",
                  align: "center",
                  width: 100,
                },
              ],
            },
          ],
        },
        {
          title: "均价",
          children: [
            {
              title: "房费",
              align: "center",
              children: [
                {
                  title: "0",
                  dataIndex: "average_house_amount",
                  key: "average_house_amount",
                  align: "center",
                  width: 100,
                },
              ],
            },
            {
              title: "净房费",
              align: "center",
              children: [
                {
                  title: "0",
                  dataIndex: "average_house_room_price",
                  key: "average_house_room_price",
                  align: "center",
                  width: 100,
                },
              ],
            },
          ],
        },
        {
          title: "RevPAR",
          children: [
            {
              title: "房费",
              align: "center",
              children: [
                {
                  title: "0",
                  dataIndex: "revpay_house_amount",
                  key: "revpay_house_amount",
                  align: "center",
                  width: 100,
                },
              ],
            },
            {
              title: "净房费",
              align: "center",
              children: [
                {
                  title: "0",
                  dataIndex: "revpay_house_room_price",
                  key: "revpay_house_room_price",
                  align: "center",
                  width: 100,
                },
              ],
            },
          ],
        },
        {
          title: "订单收支",
          children: [
            {
              title: "收入",
              align: "center",
              children: [
                {
                  title: "0",
                  dataIndex: "order_income",
                  key: "order_income",
                  align: "center",
                  width: 100,
                },
              ],
            },
            {
              title: "支出",
              align: "center",
              children: [
                {
                  title: "0",
                  dataIndex: "order_expend",
                  key: "order_expend",
                  align: "center",
                  width: 100,
                },
              ],
            },
            {
              title: "净收入",
              align: "center",
              children: [
                {
                  title: "0",
                  dataIndex: "order_income_net",
                  key: "order_income_net",
                  align: "center",
                  width: 100,
                },
              ],
            },
          ],
        },
        {
          title: "订单外收支",
          children: [
            {
              title: "收入",
              align: "center",
              children: [
                {
                  title: "0",
                  dataIndex: "income",
                  key: "income",
                  align: "center",
                  width: 100,
                },
              ],
            },
            {
              title: "支出",
              align: "center",
              children: [
                {
                  title: "0",
                  dataIndex: "expend",
                  key: "expend",
                  align: "center",
                  width: 100,
                },
              ],
            },
            {
              title: "净收入",
              align: "center",
              children: [
                {
                  title: "0",
                  dataIndex: "net_income",
                  key: "net_income",
                  align: "center",
                  width: 100,
                },
              ],
            },
          ],
        },
      ],
    });

    watch(
        () => store.state.ContentHeight,
        () => {
          table.tableHeight = countTable(search.topDom) - 120;
        }
    );

    onMounted(() => {
      search.getSearchData();
      table.getTableData();
      table.tableHeight = countTable(search.topDom) - 120;
    });

    return {
      ...toRefs(search),
      ...toRefs(table),
    };
  },
};
</script>

<style lang="scss" scoped>
.ant-tabs > .ant-tabs-nav {
  margin: 0 !important;
}

.fRed {
  color: red;
}
</style>
